







































































































































































































import {Chrome} from "vue-color";
import {Component, Watch} from "vue-property-decorator";
import FormCard from "@/components/FormCard.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import {namespace} from "vuex-class";
import {mixins} from "vue-class-component";
import ToastedMixin from "@/mixins/ToastedMixin";
import FscCard from "@/components/Card/FscCard.vue";
import CompanyMixin from "@/mixins/CompanyMixin";
import FscModal from "@/components/Modal/FscModal.vue";

const DriveBuzzConfigurationModule = namespace("drive-buzz-config");
const DrivingSchool = namespace("driving-school");

@Component({
  components: {FscModal, FscCard, FormCard, AbortButton, SaveButton, "chrome-picker": Chrome},
})
export default class DriveBuzzConfiguration extends mixins(ToastedMixin, CompanyMixin) {
  public name = "DriveBuzzConfiguration.vue";

  private myDrivingSchoolUrl = false;
  private myDrivingSchoolEnabled = null;

  private kiPilotFunctionsEnabled = null;
  private kiPilotPraxisEnabled = null;
  // private kiPilotPraxisVisible = null;
  private initialKiPilotFunctionsEnabled = null;

  protected kiPilotModal = "ki-pilot-modal";
  protected acceptedToConfigure = false;

  private bgColor = {hex: "#ffffff"}; // Initial value as object
  private textColor = {hex: "#000000"}; // Initial value as object

  private editMode = false;

  protected enableKIPilotPraxisForAllEducationsConfirmationModalId = "confirm-enable-ki-pilot-praxis-for-all-educations";
  protected acceptedToEnableKIPilotPraxis = false;
  protected settingUpEnableKIPilotPraxis = false;
  protected kiPilotPraxisEnabledCurrentValue: boolean | null = null;
  protected kiPilotPraxisVisible: boolean | null = null;

  @DriveBuzzConfigurationModule.Action("findAll")
  public driveBuzzConfigFindAll: any;

  @DriveBuzzConfigurationModule.Action("update")
  public driveBuzzConfigsUpdate: any;

  @DriveBuzzConfigurationModule.Getter("getDataList")
  public driveBuzzConfigs: any;

  @DriveBuzzConfigurationModule.Getter("getSuccess")
  public success: any;

  @DriveBuzzConfigurationModule.Getter("getError")
  public error: any;

  @DriveBuzzConfigurationModule.Getter("getIsLoading")
  public isLoading: any;

  public mounted(): void {
    this.driveBuzzConfigFindAll({
      resource: "drive-buzz-config/current",
    });

    this.kiPilotPraxisEnabledCurrentValue = this.driveBuzzConfigs.kiPilotPraxisEnabled;
    this.kiPilotPraxisVisible = this.driveBuzzConfigs.kiPilotPraxisVisible;
  }

  toggleEditMode() {
    this.editMode = !this.editMode; // Toggle the edit mode
  }

  @Watch("driveBuzzConfigs")
  private onFurtherEducationConfigsChange(data: any): void {
    if (data) {
      this.myDrivingSchoolUrl = data.myDrivingSchoolUrl;
      this.myDrivingSchoolEnabled = data.myDrivingSchoolEnabled;
      this.bgColor.hex = data.myDrivingSchoolBackgroundColorHex;
      this.textColor.hex = data.myDrivingSchoolTextColorHex;
      this.kiPilotFunctionsEnabled = data.kiPilotFunctionsEnabled;
      this.initialKiPilotFunctionsEnabled = data.kiPilotFunctionsEnabled;
      this.kiPilotPraxisEnabled = data.kiPilotPraxisEnabled;
    }
  }

  private async onSubmit(): Promise<void> {
    if (this.hasNotPermissionWrite) return;
    const data = {
      myDrivingSchoolUrl: this.myDrivingSchoolUrl,
      myDrivingSchoolEnabled: this.myDrivingSchoolEnabled,
      myDrivingSchoolBackgroundColorHex: this.bgColor.hex,
      myDrivingSchoolTextColorHex: this.textColor.hex,
      kiPilotFunctionsEnabled: this.kiPilotFunctionsEnabled,
      kiPilotPraxisEnabled: this.kiPilotPraxisEnabled
    };

    if (this.acceptedToEnableKIPilotPraxis) {
      this.settingUpEnableKIPilotPraxis = true;
    }

    await this.driveBuzzConfigsUpdate({
      id: "current",
      data: data,
      resource: "drive-buzz-config",
    });

    this.driveBuzzConfigs.kiPilotPraxisEnabled =
        this.driveBuzzConfigs.kiPilotPraxisEnabled || this.acceptedToEnableKIPilotPraxis;
    this.settingUpEnableKIPilotPraxis = false;
  }

  public onKiPilotFunctionsEnabledChange() {
    const isFirstConfiguration =
        this.initialKiPilotFunctionsEnabled === null &&
        this.kiPilotFunctionsEnabled === true;

    if (isFirstConfiguration) {
      this.$bvModal.show(this.kiPilotModal);
    }
  }

  public onKiPilotFunctionsEnabledModalFeedback(accept: boolean) {
    if (!accept) {
      this.kiPilotFunctionsEnabled = null;
    }

    this.$bvModal.hide(this.kiPilotModal);
  }

  public onEnableKIPilotPraxisChange(e: any) {
    const firstTimeTurningSwitchOn =
        this.kiPilotPraxisEnabledCurrentValue == null;
    if (firstTimeTurningSwitchOn && !this.acceptedToEnableKIPilotPraxis) {
      this.$bvModal.show(this.enableKIPilotPraxisForAllEducationsConfirmationModalId);
    }
  }

  public onEnableKIPilotPraxisModalFeedback(accept: boolean) {
    if (!accept) {
      this.acceptedToEnableKIPilotPraxis = false;
      this.driveBuzzConfigs.kiPilotPraxisEnabled = null;
      this.kiPilotPraxisEnabled = null;
    } else {
      this.acceptedToConfigure = true;
      this.kiPilotPraxisEnabledCurrentValue = true;
    }
    this.$bvModal.hide(this.enableKIPilotPraxisForAllEducationsConfirmationModalId);
  }

}
